import { InventoryUpdateDTO } from "./inventory-update.dto";
import { ActionInventory } from "./type/action-inventory.enum";

export class ActionInventoryUpdateDTO extends InventoryUpdateDTO {
  action!: ActionInventory.update;
  id!: string;
}
